import bookingsData from '@/store/modules/bookings';
import store from '@/store';
import { getLocalTime } from '@qualle-admin/qutil/dist/date';
import auth from '@/store/modules/auth';
import stripe from '../store/modules/stripe';
import { defaultOverWeight } from '@/service/defaultData';
import { phoneRegex } from '@qualle-admin/qutil/dist/patterns';
export const checkPendingBookings = () => {
  const currentTimestamp = getLocalTime().format();
  const pendingActions = bookingsData.state.bookings.filter(
    (val) =>
      (val.status === 'active' || val.status === 'pending') &&
      val.loadingDate < currentTimestamp
  );
  return pendingActions;
};

export const checkPendingCommitments = async () => {
  const pendingBookings = await checkPendingBookings();
  var pendingCommitments = [];
  if (pendingBookings.length) {
    return Promise.all(
      pendingBookings.map(async (val) => {
        const commitments = await store.dispatch(
          'bookings/get_approved_commitments_data',
          val.id,
          {
            root: true,
          }
        );
        if (commitments?.length) {
          commitments.forEach((item) => {
            item.contianersCommitted = val.committed;
            if (item.loadingDate < getLocalTime().format()) {
              pendingCommitments.push(item);
            }
          });
        }

        return pendingCommitments;
      })
    );
  } else {
    return pendingCommitments;
  }
};

// subscription plans required to request export loads
export const planRequiredToRequestExportLoads = [
  'basic',
  'premium',
  'unlimited',
];

export const validateTruckerDetails = () => {
  const orgData = auth.state.organization;
  const validateTruckerDetails =
    orgData?.numberOfTrucks > 0 &&
    orgData?.operatingRegions.length > 0 &&
    orgData?.insuranceCoverage &&
    orgData?.weightAuthorization &&
    orgData?.mcNumber > 0;
  if (!validateTruckerDetails) {
    return false;
  } else {
    return true;
  }
  // errorNotification(
  //   'To request export load please add trucker details in accounts settings.'
  // );
};
export const validateVendorDetails = () => {
  const orgData = auth.state.organization;
  let validateVendorDetails = false;
  validateVendorDetails =
    orgData.vendor_details?.primaryContact &&
    orgData.vendor_details?.primaryContactName &&
    orgData.vendor_details?.primaryContactName.length > 0 &&
    validatePhoneNumber(orgData.vendor_details?.primaryContact);

  if (validateVendorDetails) {
    if (
      orgData.vendor_details?.secondaryContact !== '' &&
      orgData.vendor_details?.secondaryContact !== null &&
      orgData.vendor_details?.secondaryContact !== undefined
    ) {
      validateVendorDetails = validatePhoneNumber(
        orgData.vendor_details?.secondaryContact
      );
    }
  }

  return validateVendorDetails;
};
export const validatePhoneNumber = (value) => {
  if (phoneRegex.test(value) === true) {
    return true;
  } else {
    return phoneRegex.test(value);
  }
};
export const validateInsuranceCoverage = (insurance) => {
  if (insurance > auth.state.organization.insuranceCoverage) {
    // errorNotification(
    //   'Our records indicate you did not meet the insurance requirements for this shipment. If this is incorrect, please update your profile and try again.'
    // );
    return false;
  } else return true;
};
export const validateWeightAuthorization = (weight) => {
  if (
    weight >= defaultOverWeight &&
    auth.state.organization.weightAuthorization === 'Legal'
  ) {
    // errorNotification(
    //   'Our records indicate that you are not authorized to move overweight shipments, if this is incorrect, please update your profile and try again.'
    // );
    return false;
  } else return true;
};
export const validateSubscriptionPlan = () => {
  if (
    stripe.state.subscription &&
    stripe.state.subscription?.status === 'active' &&
    planRequiredToRequestExportLoads.find((plan) =>
      stripe.state.subscription?.plan?.nickname?.toLowerCase().includes(plan)
    )
  ) {
    return true;
  } else return false;
};

export const validatePaymentMethods = () => {
  const paymentMethods = stripe.state.payment_methods;
  if (paymentMethods.length) {
    const defaultPaymentMethod = paymentMethods.find(
      (val) => val.is_default === true
    );
    if (defaultPaymentMethod) {
      return true;
    } else {
      return false;
    }
  }
};
